<div class="flex justify-space-between align-items-center">
    <h2 class="text-heading" [ngClass]="{ 'ion-no-margin': headingNoMargin }">{{ heading }}</h2>
    <lib-button
        [disabled]="disabled"
        *ngIf="buttonText || iconName"
        [displayAsInlineText]="true"
        (onClick)="onClick.emit()">
        <lib-svg-icon
            *ngIf="iconName"
            [iconName]="iconName"
            color="var(--ion-color-orange)"
            class="margin-right-small" />
        {{ buttonText }}
    </lib-button>
</div>
